import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faFileContract, faCalendar, faGavel } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';

import { DeleteButton, DownloadButton, EditButton } from '../../components/TableActionButtons';

// Add this helper function for constitution badge styling
const getConstitutionBadge = () => {
    return (
        <span className="inline-flex items-center px-2 py-1 bg-green-500/20 text-green-600 text-xs font-semibold rounded-md border border-green-500/30 ml-2 transition-all duration-200 hover:bg-green-500/30">
            <div className="w-1 h-1 bg-green-600 rounded-full mr-1.5"></div>
            Constitution
        </span>
    );
};

export const getConstitutionsTableConfig = (truncateDescription, handleEdit, handleDelete, handleDownload, downloadingId = null) => [
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faGavel} className="w-4 h-4 mr-2" />
                TITLE AND DESCRIPTION
            </span>
        ),
        accessorKey: 'title',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex items-center">
                    <FontAwesomeIcon icon={faFileContract} className="w-4 h-4 mr-2" />
                    <span className="font-medium">{row.original.title}</span>
                    {getConstitutionBadge()}
                </div>
                <div className="text-left mt-1">{row.original.description && <span className="text-gray-500 text-sm line-clamp-2">{truncateDescription(row.original.description)}</span>}</div>
            </div>
        )
    },

    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faCalendar} className="w-4 h-4 mr-2" />
                DATE
            </span>
        ),
        accessorKey: 'date',
        cell: ({ row }) => {
            const date = new Date(row.original.date);
            return (
                <div className="text-left">
                    {date.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })}
                </div>
            );
        }
    },

    {
        header: () => (
            <span className="flex items-center justify-center">
                <FontAwesomeIcon icon={faCog} className="w-4 h-4 mr-2" />
                ACTIONS
            </span>
        ),
        id: 'actions',
        cell: ({ row }) => (
            <div className="flex items-center justify-center gap-3">
                <EditButton onClick={() => handleEdit(row.original)} row={row} />
                <DeleteButton onClick={() => handleDelete(row.original)} row={row} />
                <DownloadButton 
                    onClick={() => handleDownload(row.original)} 
                    row={row} 
                    isLoading={downloadingId === row.original.id}
                />
            </div>
        )
    }
];

export const INITIAL_FORM_STATE = {
    title: '',
    description: '',
    date: '',
    thumbnail: ''
};

export const INITIAL_FILES_STATE = {
    manual: null,
    thumbnail: null
};

export const INITIAL_FORM_ERRORS = {
    title: '',
    description: '',
    date: '',
    thumbnail: '',
    manual: ''
};

export const PAGE_CONFIG = {
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Constitutions', link: '/constitutions' }
    ],
    PAGE_TITLE: 'Constitutions',
    GET_QUERY_KEY: 'constitutions',
    API_CALL: () => api.constitutions.getConstitutions(),
    DEFAULT_ERROR_MESSAGE: 'Failed to fetch constitutions',
    SELECT: (data) => data?.data,
    //Delete
    DELETE_API_CALL: (id) => api.constitutions.deleteConstitution(id),
    DELETE_ERROR_MESSAGE: 'Failed to delete constitution',
    DELETE_SUCCESS_MESSAGE: 'Constitution deleted successfully',
    //Create
    CREATE_API_CALL: (data) => api.constitutions.createConstitution(data),
    CREATE_ERROR_MESSAGE: 'Failed to create constitution',
    CREATE_SUCCESS_MESSAGE: 'Constitution created successfully',
    // Update
    UPDATE_API_CALL: (id, data) => api.constitutions.updateConstitution(id, data),
    UPDATE_ERROR_MESSAGE: 'Failed to update constitution',
    UPDATE_SUCCESS_MESSAGE: 'Constitution updated successfully'
};



